import { IntegrationField } from 'api/integrations';
import { Field } from 'api/tasks';
import {
  FilterableField,
  filterableFieldType,
} from 'components/organisms/tasks/fields';

// TODO: remove 'unknown', extend Field Type
export const convertIntegrationFieldToField = (fields: IntegrationField[]) =>
  fields.map(
    (field) =>
      ({
        ...field,
        fieldId: field.integrationFieldId,
        integrationFieldId: undefined,
        type: filterableFieldType(field as unknown as Field),
        metaData: {
          ...(field.metaData ?? {}),
          options: field.metaData?.options?.map((option) => ({
            ...option,
            value: option.valueStr,
          })),
        },
      } as unknown as FilterableField),
  );
